const EMAIL_RE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function check(obj, element, label) {
	if (!element) {
		obj.push(`Insira o ${label}`)
	} else {
		let err = ""
		let docElement = document.getElementById('document');
		let docErr = docElement ? docElement.getAttribute('validate-error') == "true" : false;
		let cleanElement = typeof element === 'string' ? element.replace(/\D/g, '') : element;

		if (label == "CPF" && (!validateCPF(cleanElement) || docErr)) {
			err = `${label} inválido`
		} else if (label == "CNPJ" && (!validateCNPJ(cleanElement) || docErr) ) { 
			err = `${label} ${docErr? "já cadastrado": "inválido"}`
		} else if (label == "Email" && !EMAIL_RE.test(element)) {
			err = `${label} inválido`
		} else if (element.length < 3) {
			err = `${label} muito curto`
		} 
		if (err) {
			obj.push(err)
		}
	}
}
export function personValidate(props) {
	const { name, email, phone_number } = props
	let errors = []
	check(errors, name, 'Nome')
	check(errors, email, 'Email')
	check(errors, phone_number, 'Telefone')

	const data = { name, email, phone_number }

	return { errors, data }
}

export function addressValidate(props, required = true) {
	const data = { errors: [] }
	const { cityLocation: city_location, complement, district, postalCode: postal_code, stateLocation: state_location, streetNumber: street_number, street } = props
	const isEmpty = !city_location && !complement && !district && !postal_code && !state_location && !street_number && !street

	function validateAddress() {
		if (!state_location) {
			data.errors.push('Informe o estado')
		}
		if (!city_location) {
			data.errors.push('Informe a cidade')
		}
		if (!district) {
			data.errors.push('Informe o bairro')
		}
		if (!postal_code) {
			data.errors.push('Informe o CEP')
		} else {
			if (postal_code.length < 8) {
				data.errors.push('CEP Inválido')
			}
		}
		if (!street) {
			data.errors.push('Informe a rua')
		}

	}

	if (required) {
		if (isEmpty) {
			data.errors.push('Informe o endereço')
			return data
		} else {
			validateAddress()
			if (!data.errors.length) {
				data.address = {
					state_location: state_location.id,
					city_location: city_location.id,
					complement,
					district,
					postal_code,
					street_number,
					street

				}
			}
			return data
		}
	} else {
		if (!isEmpty) {
			validateAddress()
			if (!data.errors.length) {
				data.address = {
					state_location: state_location.id,
					city_location: city_location.id,
					complement,
					district,
					postal_code,
					street_number,
					street

				}
			}
			return data
		} else {
			return data
		}
	}
}


export function validateCPF(cpf) {
	let mod, total = 0, i = 0, sequence = 10

	for (let x = sequence; x > 1; x--) {
		total += (x * Number(cpf[i]))
		i++
	}

	mod = Number(total * 10 % 11)
	if (mod === 10) mod = 0

	if (!(Number(cpf[9]) === mod))
		return false

	total = 0
	i = 0
	mod = 0
	for (let x = sequence + 1; x > 1; x--) {
		total += x * Number(cpf[i])
		i++
	}
	mod = Number(total * 10 % 11)
	if (mod === 10) mod = 0

	if (!(Number(cpf[10]) === mod)) {
		return false
	}
	return true
}
export function validateCNPJ(cnpj) {

	const cnpjWeight1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
	const cnpjWeight2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
	let total = 0, i = 0, verifiedDigit = 0

	cnpjWeight1.forEach(digit => {
		total += digit * Number(cnpj[i])
		i++
	})
	let mod = Number(total % 11)
	if (!(mod < 2)) {
		verifiedDigit = 11 - mod
	}
	if (!(Number(cnpj[12]) === Number(verifiedDigit))) {
		return false
	}
	total = verifiedDigit = i = mod = 0

	cnpjWeight2.forEach(digit => {
		total += digit * Number(cnpj[i])
		i++
	})

	mod = Number(total % 11)
	if (!(mod < 2)) {
		verifiedDigit = 11 - mod
	}
	if (!(Number(cnpj[13]) === Number(verifiedDigit))) {
		return false
	}
	return true
}
export function valideteDocument(props) {
	const { type, doc } = props
	let errors = []
	check(errors, doc, [0,3].includes(type) ? "CPF" : "CNPJ")

	return errors
}

export function validateCompany(props) {
	const {fancyName, stateRegistry} = props 
	let errors = []

	check(errors, fancyName, "Nome Fantasia")
	check(errors, stateRegistry, "Inscrição estadual")

	return errors
}



// WEBPACK FOOTER //
// ./src/components/parts/person/utils/index.js